import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const FlexWrapper = styled.div(
  (props: {
    alignItems?: string;
    justifyContent?: string;
    direction?: string;
    width?: string;
  }) =>
    mq({
      display: 'flex',
      flexDirection: props.direction,
      justifyContent: props.justifyContent,
      alignItems: props.alignItems,
      width: props.width ? props.width : '100%',
    }),
);

export const RaceInfoWrapper = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: ['column', 'row'],
    justifyContent: 'space-between',
    alignItems: ['flex-start', 'center'],
    borderBottom: `${defaultTheme.spacing.xs} solid ${defaultTheme.border.color.lightGray}`,
    backgroundColor: defaultTheme.background.white,
    padding: defaultTheme.spacing.l,
  }),
);

export const RaceInfo = styled.div(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
    fontSize: defaultTheme.font.size.s,
    fontWeight: 'bold',
    span: {
      fontSize: defaultTheme.font.size.xl,
      marginRight: defaultTheme.spacing.xs,
    },
  }),
);

export const DeadLineText = styled.p(() =>
  mq({
    fontSize: defaultTheme.font.size.s,
    fontWeight: 'bold',
    lineHeight: defaultTheme.font.height.base,
    marginTop: [defaultTheme.spacing.s, 0],
  }),
);

export const TicketInfo = styled.div(() =>
  mq({
    borderBottom: `${defaultTheme.spacing.xs} solid ${defaultTheme.border.color.lightGray}`,
    backgroundColor: defaultTheme.background.white,
    padding: defaultTheme.spacing.l,
  }),
);

export const TicketTypeWrapper = styled.div(() =>
  mq({
    fontSize: defaultTheme.font.size.m,
    fontWeight: 'bold',
    p: {
      marginBottom: defaultTheme.spacing.xs,
    },
  }),
);

export const ButtonWrapper = styled.div(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
    '& > button': {
      marginLeft: defaultTheme.spacing.s,
    },
  }),
);
